import { helpers, required } from 'vuelidate/lib/validators'

/**
 * Model "class" for Practice - defines useful field metadata for building and validating forms
 */

// custom validator for phone numbers
const phoneNumber = (value) => {
    return !helpers.req(value) || value == '' || /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/.test(value)
}

export default {
    fields: {
        name: {
            label: 'FIELD_PRACTICE_NAME',
            type: 'text',
        },
        npi: {
            label: 'FIELD_PRACTICE_NPI',
            type: 'text',
        },
        practice_code_id: {
            label: 'FIELD_PRACTICE_CODE',
            type: 'typeahead',
            placeholder: 'FIELD_PRACTICE_CODE_PLACEHOLDER',
            getFieldObject: (practice) => {
                return practice.practiceCode
            },
            typeaheadToString: (practiceCode) => {
                if (practiceCode) {
                    return `${practiceCode.code} - ${practiceCode.display_name}`
                } else {
                    return ''
                }
            },
            doTypeaheadSearch: (vue, modelInstance, searchText) => {
                return vue.$api.findPracticeCodes(vue, searchText)
            },
        },
        emr_id: {
            label: 'FIELD_PRACTICE_EMR_ID',
            labelSlot: 'emr',
            type: 'text',
            validations: { maxLength: 127 },
        },
        address: {
            label: 'FIELD_PRACTICE_ADDRESS',
            type: 'text',
        },
        address2: {
            label: 'FIELD_PRACTICE_ADDRESS2',
            type: 'text',
        },
        city: {
            label: 'FIELD_PRACTICE_CITY',
            type: 'text',
        },
        state: {
            label: 'FIELD_PRACTICE_STATE',
            type: 'text',
        },
        zip: {
            label: 'FIELD_PRACTICE_ZIP',
            type: 'text',
        },
        email: {
            label: 'FIELD_PRACTICE_EMAIL',
            type: 'email',
            validations: {required}
        },
        phone: {
            label: 'FIELD_PRACTICE_PHONE',
            type: 'tel',
            validations: { phoneNumber: phoneNumber },
            invalidFeedback: { phoneNumber: 'MESSAGE_PHONE_NUMBER_FORMAT' }
        },
        fax: {
            label: 'FIELD_PRACTICE_FAX',
            type: 'tel',
            validations: { phoneNumber: phoneNumber },
            invalidFeedback: { phoneNumber: 'MESSAGE_PHONE_NUMBER_FORMAT' }
        },
        type: {
            label: 'FIELD_PRACTICE_TYPE',
            type: 'checks',
            options: {
                PRIMARY: 'FIELD_PRACTICE_TYPE_PRIMARY',
                SPECIALIST: 'FIELD_PRACTICE_TYPE_SPECIALIST',
                COACH: 'FIELD_PRACTICE_TYPE_WELLNESS_COACH',
                MENTOR: 'FIELD_PRACTICE_TYPE_HEALTH_MENTOR',
            },
        },
        website: {
            label: 'FIELD_PRACTICE_WEBSITE',
            type: 'text',
        },
        comment: {
            label: 'FIELD_PRACTICE_COMMENT',
            type: 'textarea',
        },
        disabled: {
            label: 'FIELD_PRACTICE_DISABLED',
            type: 'check',
        },
        use_dietid_questionnaire: {
            label: 'FIELD_PRACTICE_DIET_QUESTIONNAIRE',
            type: 'select',
            options: {
                1: 'FIELD_PRACTICE_DIET_QUESTIONNAIRE_OPTION_DIETID',
                0: 'FIELD_PRACTICE_DIET_QUESTIONNAIRE_OPTION_DIET',
            }
        }
    }
}
